import PropTypes from 'prop-types';
import { useEffect, useState, useCallback } from 'react';
// @mui
import { Stack, Button, TextField, DialogTitle, DialogActions, DialogContent, Dialog, FormControl, InputLabel, MenuItem, FormGroup, Switch, FormControlLabel, Autocomplete, Chip } from '@mui/material';
// components
import Iconify from 'src/components/iconify';
import { Upload } from 'src/components/upload';


// ----------------------------------------------------------------------
// const Accesstpe = [
//   {value: ""}
// ]
const options = ["bo", "tm", "ta", "te"];

export default function FileManagerNewFolderDialog({
  title = 'Upload Files',
  open,
  onClose,
  //
  onCreate,
  onUpdate,
  //
  folderName,
  onChangeFolderName,
  allusers,
  setSearchUser,
  setFormFolder,
  formFolder,
  ...other
}) {
 
  const [checked, setChecked] = useState(true);
  const [value, setValue] = useState([]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormFolder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

    const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormFolder((prev) => ({
      ...prev,
      [name]: checked
    }));
  };


  const handleAccessibleToUser = (event, newValue) => {
    setFormFolder((prev) => ({
      ...prev,
      accessibleToUsers: newValue
    }))
  }
    const handleAccessibleToGroup = (event, newValue) => {
      console.log(newValue)
    setFormFolder((prev) => ({
      ...prev,
      accessibleToGroups: newValue
    }))
  }


  

  // useEffect(() => {
  //   if (!open) {
  //     setFiles([]);
  //   }
  // }, [open]);

const handleDrop = useCallback((acceptedFiles) => {
  const newFiles = acceptedFiles.map((file) => {
    const preview = URL.createObjectURL(file);
    return Object.assign(file, { preview });
  });

  const dbFiles = acceptedFiles.map((file) => ({
    name: file.name,
    type: file.type,
    size: file.size,
    path: file.path || '', 
  }));

  setFormFolder((prev) => ({
    ...prev,
    files: [...(prev.files || []), ...dbFiles],    
    uploadFiles: newFiles 
  }));

  
}, []);

  const handleUpload = () => {
    onClose();
    console.info('ON UPLOAD');
  };

  const handleRemoveFile = (inputFile) => {
    const filtered = formFolder?.files.filter((file) => file !== inputFile);
        setFormFolder((prev) => ({
      ...prev,
      files: filtered
    }))
  };

  const handleRemoveAllFiles = () => {
        setFormFolder((prev) => ({
      ...prev,
      files: []
    }))
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}> {title} </DialogTitle>

      <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
        <TextField
          name='name'
          fullWidth
          label="Folder name"
          value={formFolder?.name}
          onChange={handleChange}
          sx={{ mb: 3 }}
        />
        <FormGroup sx={{mb: 2}}>
          <FormControlLabel name='isIndividual' control={<Switch onChange={handleCheckboxChange} checked={formFolder?.isIndividual} />} label="Individual?" />
        </FormGroup>
        {
          formFolder?.isIndividual ?
              <Autocomplete
                multiple
                options={allusers || []}
                 getOptionLabel={(option) => option.fullName || ''}
                value={formFolder.accessibleToUsers}
                onChange={(event, newValue) => handleAccessibleToUser(event, newValue)}
                onInputChange={(event, newInputValue) => setSearchUser(newInputValue)}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip label={option.fullName} {...getTagProps({ index })} key={option._id} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select User"
                    placeholder="Users"
                  />
                )}
              />
            :
            <Autocomplete
              multiple
              options={options || []}
              getOptionLabel={(option) => option.toUpperCase() || ''}
              value={formFolder?.accessibleToGroups}
              onChange={(event, newValue) => handleAccessibleToGroup(event, newValue)}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option?.toUpperCase()} {...getTagProps({ index })} key={option} />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Role"
                  placeholder="Role"
                />
              )}
            />
        }



        <Upload multiple files={formFolder?.files} onDrop={handleDrop} onRemove={handleRemoveFile} sx={{mt: 2}}/>
      </DialogContent>

      <DialogActions>
        {/* <Button
          variant="contained"
          startIcon={<Iconify icon="eva:cloud-upload-fill" />}
          onClick={handleUpload}
        >
          Upload
        </Button>

        {!!formFolder?.files?.length && (
          <Button variant="outlined" color="inherit" onClick={handleRemoveAllFiles}>
            Remove all
          </Button>
        )} */}

        {(onCreate || onUpdate) && (
          <Stack direction="row" justifyContent="flex-end" flexGrow={1}>
            <Button variant="soft" onClick={formFolder?._id ? onUpdate : onCreate}>
              {formFolder?._id ? 'Save' : 'Create'}
            </Button>
            <Button variant="soft" onClick={onClose}>
              Close
            </Button>
          </Stack>
        )}
      </DialogActions>
    </Dialog>
  );
}

FileManagerNewFolderDialog.propTypes = {
  folderName: PropTypes.string,
  onChangeFolderName: PropTypes.func,
  onClose: PropTypes.func,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  allusers: PropTypes.array,
  setSearchUser: PropTypes.func,
  setFormFolder: PropTypes.func,
  formFolder: PropTypes.object
};
